import FontFaceObserver from 'fontfaceobserver';
import modular from "modujs";
import * as modules from "./modules";
import globals from "./globals";
import { html } from "./utils/environment";

(() => {
    const modularApp = new modular({
        modules: modules,
    });

     // Is Mobile
     window.isMobile = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

     if(window.isMobile) {
         html.classList.add('is-mobile');
     }

    //////////////////
    //  Application
    /////////////////
    const app = {
        // Init
        init() {
            // Load styles
            const $style = document.getElementById("stylesheet");

            const onStyleLoaded = () => {
                console.log(`%c${"[Styles]: Loaded"}`, `color: #9d4edd;`);
                $style.removeEventListener("load", onStyleLoaded);
                this.start();
            };

            console.log(`%c${"[Styles]: Loading"}`, `color: #9d4edd;`);

            // Check style loading state
            if ($style.isLoaded) {
                onStyleLoaded();
            } else {
                $style.addEventListener("load", onStyleLoaded);
            }

            // Debug focus
            document.addEventListener('focusin', function() {
                //console.log('focused: ', document.activeElement)
            }, true);            
        },

        // Start App
        start() {
            console.log(`%c${"[App]: Start"}`, `color: #5bc0be;`);

            // bind events
            this.bindEvents()

            globals();

            modularApp.init(modularApp);

            html.classList.add("is-first-hit");
            html.classList.add("is-loaded");
            html.classList.remove("is-loading");

            // Load fonts
            this.fontsLoader(
                [
                    'AeonikPro-Medium',
                    'AeonikPro-Regular',
                    'MaisonNeue-Mono',
                    'Druk-WideMedium',
                    'MonopolTRIALKompakt'
                ],
                () => {
                    html.classList.add("is-fonts-loaded");
                }
            )
        },

        async fontsLoader(fonts, callback) {
            const fontFaceObservers = []

            if (!fonts.length) return

            fonts.forEach((fontFamily) => {
              const observer = new FontFaceObserver(fontFamily)
              fontFaceObservers.push(observer)
            })

            try {
                await Promise.all(fontFaceObservers);
                callback?.()
            } catch (err) {
                console.warn('Some critical font are not available:', err);
            }
        },

        // Hooks
        onInteractive(event) {
            console.log(`%c${"[Document]: Interactive"}`, `color: #ffc857;`);

            // Internet Explorer 6-11
            const isIE = /*@cc_on!@*/false || !!document.documentMode;
            const $browserSupportContainer = document.querySelector('.js-outdated');

            if (isIE) {
                $browserSupportContainer.classList.add('is-active')
            } else {
                document.body.removeChild($browserSupportContainer)
                this.init();
            }
        },

        onComplete(event) {
            console.log(`%c${"[Document]: Complete"}`, `color: #ffc857;`);
            html.classList.add("is-ready");

            setTimeout(() => {
                console.log(`%c${"[Document]: Complete => Animation completed"}`, `color: #ffc857;`);
                html.classList.add("is-anim-completed");
            }, 600)
        },

        // Global event
        bindEvents() {
            if (window.isMobile) {
                window.addEventListener("resize", this.onMobileResize);
                this.onMobileResize();
            } else {
                // Resize event
                window.addEventListener("resize", this.onResize);
                this.onResize();
            }
        },

        onResize() {
            let vw = html.offsetWidth * 0.01;
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vw', `${vw}px`);
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        },

        onMobileResize() {
            if(window.innerWidth > window.innerHeight && window.customOrientation != "landscape") {
                window.customOrientation = "landscape"
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty("--vh", `${vh}px`);
            }
               
            if(window.innerWidth < window.innerHeight && window.customOrientation != "portrait") {
                window.customOrientation = "portrait"
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty("--vh", `${vh}px`);
            }
        }
    };

    //////////////////
    // Event
    /////////////////
    document.addEventListener("readystatechange", (event) => {
        switch (document.readyState) {
            case "interactive":
                app.onInteractive?.(event);
                break;
            case "complete":
                app.onComplete?.(event);
                break;
        }
    });
})();
